import Store from '../store';

const baseVirtualUrl = '/membership/application-form/';

function pushToData(virtualUrl) {
  if (process.env.NODE_ENV === 'development') {
    console.info(virtualUrl);
  }
  Store.commit('pushToDataLayer', { event: 'virtualPageview', virtualUrl });
}

function sendMembershipEvent(membershipType, eventAction) {
  const eventLabel = `${baseVirtualUrl}${eventAction}/${membershipType.toLowerCase()}`;
  pushToData(eventLabel);
}

export default {
  sendMembershipCategory(membershipType) {
    sendMembershipEvent(membershipType, 'membership-category');
  },
  sendEmploymentDetails(membershipType) {
    sendMembershipEvent(membershipType, 'employment-details');
  },
  sendUserRegistered(membershipType) {
    sendMembershipEvent(membershipType, 'user-registration');
  },
  sendCorrespondence(membershipType) {
    sendMembershipEvent(membershipType, 'correspondence-details');
  },
  sendCardPayment(membershipType) {
    sendMembershipEvent(membershipType, 'payment/options');
  },
  sendCardPaymentType(membershipType, paymentMethod) {
    sendMembershipEvent(membershipType, `payment/card/${paymentMethod}`);
  },
  sendDirectDebit(membershipType, frequency) {
    sendMembershipEvent(membershipType, `payment/directdebit-${frequency.toLowerCase()}`);
  },
  sendConfirmation(membershipType) {
    sendMembershipEvent(membershipType, 'confirmation');
  },
  sendTransaction(membershipType, totalAmount, transactionId) {
    const transaction = {
      transactionId,
      transactionAffiliation: 'Application',
      transactionTotal: totalAmount,
      transactionTax: 0,
      transactionShipping: 0,
      transactionProducts: [{
        sku: `RPSMA${membershipType}`,
        name: membershipType,
        category: 'Application',
        price: totalAmount,
        quantity: 1,
      }],

      event: 'transactionComplete',
    };

    Store.commit('pushToDataLayer', transaction);
  },
  sendDDGuarantee(membershipType) {
    if (window.ga) {
      const tracker = window.ga.getAll()[0];
      tracker.send({
        hitType: 'event',
        eventCategory: 'Information',
        eventAction: 'Application Form',
        eventLabel: `Direct Debit Guarantee - ${membershipType.toLowerCase()}`,
      });
    }
  },
  sendApplicationInvoked() {
    pushToData(baseVirtualUrl);
  },
};
